"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("header", { class: "flex justify-center px-5" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "w-full max-w-screen-xl" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("h1", { class: "uppercase text-4xl leading-squished font-black my-10" }, " Upcoming ")
    ])
], -1);
const _hoisted_2 = { class: "bg-beige-200 flex justify-center px-5 pt-10 pb-20" };
const _hoisted_3 = { class: "w-full max-w-screen-xl" };
const _hoisted_4 = {
    key: 1,
    class: "text-center text-lg"
};
const _hoisted_5 = {
    key: 2,
    class: "text-center text-lg"
};
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "We can't find anything using those filter options.", -1);
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = {
    key: 3,
    class: "text-center"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Load More Results", -1);
const ListingPreviewGrid_vue_1 = __importDefault(require("./ListingPreviewGrid.vue"));
const ListingPreviewList_vue_1 = __importDefault(require("./ListingPreviewList.vue"));
const ButtonIcon_vue_1 = __importDefault(require("../ButtonIcon.vue"));
const Listings_1 = require("../../stores/Listings");
const pinia_1 = require("pinia");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListingsList',
    setup(__props) {
        const store = (0, Listings_1.useListingsStore)();
        const { listings, loadingListings } = (0, pinia_1.storeToRefs)(store);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                _hoisted_1,
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        ((0, vue_2.unref)(listings).length > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: (0, vue_2.normalizeClass)(["w-full grid grid-cols-1 mb-11", (0, vue_2.unref)(store).$state.view === 'grid' ? 'md:grid-cols-2 lg:grid-cols-3 gap-10' : 'gap-6'])
                            }, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(store).$state.listings, (listing) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)((0, vue_2.unref)(store).$state.view === 'list' ? ListingPreviewList_vue_1.default : ListingPreviewGrid_vue_1.default), {
                                        key: listing.slug,
                                        listing: listing
                                    }, null, 8, ["listing"]));
                                }), 128))
                            ], 2))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.unref)(loadingListings))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, "¡Un momento!"))
                            : ((0, vue_2.unref)(listings).length === 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, _hoisted_7))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                    (!(0, vue_2.unref)(store).$state.lastListing)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(
                                            //@ts-ignore
                                            (...args) => ((0, vue_2.unref)(store).loadMore && (0, vue_2.unref)(store).loadMore(...args)), ["prevent"])),
                                            class: "button button-outlined button-red-500 hover:button-red-400 text-mutedpurple-800 hover:text-mutedpurple-800 pl-3",
                                            disabled: (0, vue_2.unref)(store).$state.loadingListings || (0, vue_2.unref)(store).$state.lastListing
                                        }, [
                                            (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                            _hoisted_10
                                        ], 8, _hoisted_9))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                    ])
                ])
            ], 64));
        };
    }
});
